import { render, staticRenderFns } from "./RadioRender.vue?vue&type=template&id=19afb7ba&"
import script from "./RadioRender.vue?vue&type=script&lang=js&"
export * from "./RadioRender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports